<script>
import accesslevels from '@utils/accesslevels'
import { toasterMethods, voaFiservReportMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
    orderData: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      messageType: '',
      source: 'CPSS UI',
      alertMessage: '',
      showSpinner: false,
      refreshPeriodTypes: [],
      referenceNumber: '',
      borrowerFirstName: '',
      borrowerMiddleName: '',
      borrowerLastName: '',
      borrowerSSN: '',
      email: '',
      PhoneNumber: '',
      showmessage: false,
      orderId: '',
      transactionHistory: '',
      refreshPeriod: '',
      autherror: '',
    }
  },
  computed: {
    placeholders() {
      return {
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        ssn: 'xxx-xx-xxxx',
        referenceNumber: 'Reference Number',
        email: 'Email ID',
        phoneNumber: '(xxx) xxx-xxxx',
      }
    },
    isCustRequestor() {
      return accesslevels(9)
    },
    transactionHistoryList() {
      return this.$_transactionHistoryList
    },
  },
  mounted() {
    for (var i = 0; i < this.productAddOns.length; i++) {
      if (this.productAddOns[i].changeable === true) {
        this.refreshPeriodTypes.push({
          text: this.productAddOns[i].name,
          value: this.productAddOns[i].productAddOnId,
        })
      }
    }
  },

  methods: {
    ...voaFiservReportMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    buildVoaFiservRequest() {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      let custUserId
      if (this.isCustRequestor) {
        custUserId = userInfo.userId
      } else {
        custUserId = this.customerUserId
      }
      let VoaFiservRequestObj = {
        userId: userInfo.userId,
        Source: this.source,
        productId: this.productId,
        OrderForUser: custUserId,
        OrderForCustomer: this.customerId,
        customerId: this.customerId,
        referenceNumber: this.referenceNumber,
        transactionHistory: this.getActualDaysPeriod(this.transactionHistory),
        refreshPeriod: this.getActualDaysPeriod(this.refreshPeriod),
        borrowerRequestViewModel: {
          firstName: this.borrowerFirstName,
          middleName: this.borrowerMiddleName,
          lastName: this.borrowerLastName,
          ssn: this.borrowerSSN,
          emailAddress: this.email,
          phoneNumber: this.PhoneNumber.replace(/[^0-9]/g, ''),
        },
      }

      return VoaFiservRequestObj
    },
    getActualDaysPeriod(dayId) {
      switch(dayId) {
        case "209":
        case "128":
          return constant.thirtyDayValue
        case "129":
        case "210":
          return constant.sixtyDayValue
        case "130":
        case "211":
          return constant.nintyDayValue
        case '142':
        case '131':
          return constant.threeSixtyFiveDayValue
      }
    },
    onVoaFiservReportSubmit() {
      var isOrderReportComponentValid = false
      var isVoEReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoEReportComponentValid = response
          if (isOrderReportComponentValid && isVoEReportComponentValid) {
            this.showSpinner = true
            that
              .generateVoAFiservreports(that.buildVoaFiservRequest())
              .then((response) => {
                let respData = response.data || response
                if (response && response.data.responseStatus === 0) {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: response.data.message,
                    variant: constant.errorMessagetype,
                  })
                } else {
                  // let respData = response.data || response
                  if (respData.message === 'Success') {
                    // this.setAlert({
                    //   title: constant.imageHeaderSuccess,
                    //   msg: 'Order successfully placed',
                    //   variant: constant.successMessagetype,
                    // })
                    this.$router.push({
                      name: 'voaFiservSummary',
                      params: {
                        orderId: respData.id,
                      },
                      query: {
                        origin: constant.origin.VoaFiservReport,
                      },
                    })
                  }
                  /* if (respData.orderId !== undefined) {
                    this.$router.push({
                      name: 'voaResults',
                      params: {
                        orderId: respData.orderId,
                        callOrigin: constant.origin.OrderReport,
                        productId: this.productId,
                      },
                    })
                  } */
                }

                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.autherror = error
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
              })
          }
        })
      })
    },
  },
}
</script>
<template>
  <section>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-form @submit.prevent="onVoaFiservReportSubmit">
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="referenceNumber"
            v-model="referenceNumber"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="referenceNumber"
            maxlength="50"
            label-content="Reference Number"
            data-vv-as="Reference No."
            mark-required
            :placeholder="placeholders.referenceNumber"
          />
          <div class="error">
            {{ errors.first('referenceNumber') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="Transaction History" />
          <BaseDropdown
            v-model="transactionHistory"
            v-validate="'required'"
            :field-id="transactionHistory"
            :options="transactionHistoryList"
            data-vv-as="Transaction History"
            name="transactionHistory"
          ></BaseDropdown>
          <div class="error">
            {{ errors.first('transactionHistory') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseELabel mark-required label="Refresh Period" />
          <BaseDropdown
            v-model="refreshPeriod"
            v-validate="'required'"
            :field-id="refreshPeriod"
            :options="refreshPeriodTypes"
            data-vv-as="Refresh period"
            name="refreshPeriod"
          ></BaseDropdown>
          <div class="error">
            {{ errors.first('refreshPeriod') }}
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3" align-v="center">
        <b-col md="auto">
          <div>
            <BaseELabel
              :class="$style.labelSubHeading"
              label="Borrower Information"
            />
          </div>
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="borrowerFirstName"
            v-model="borrowerFirstName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="borrowerFirstName"
            maxlength="50"
            label-content="First Name"
            data-vv-as="First Name"
            mark-required
            :placeholder="placeholders.firstName"
          />
          <div class="error">
            {{ errors.first('borrowerFirstName') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="borrowerMiddleName"
            v-model="borrowerMiddleName"
            v-validate="{ required: false }"
            data-vv-as="Middle Name"
            type="text"
            name="borrowerMiddleName"
            maxlength="50"
            label-content="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('borrowerMiddleName'),
            }"
            :placeholder="placeholders.middleName"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerMiddleName') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="borrowerLastName"
            v-model="borrowerLastName"
            v-validate="{ required: true, regex: /^[A-Za-z0-9 ]+$/ }"
            validattor="^[A-Za-z0-9]+$"
            type="text"
            name="borrowerLastName"
            maxlength="50"
            label-content="Last Name"
            data-vv-as="Last Name"
            mark-required
            :placeholder="placeholders.lastName"
          />
          <div class="error">
            {{ errors.first('borrowerLastName') }}
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3">
          <BaseEInputText
            id="borrowerSSN"
            v-model="borrowerSSN"
            v-validate="{ required: true, regex: /^\d{3}-?\d{2}-?\d{4}$/ }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            type="text"
            maxlength="11"
            name="borrowerSSN"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :placeholder="placeholders.ssn"
          />
          <div class="error">
            {{ errors.first('borrowerSSN') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="borrower-email"
            v-model="email"
            v-validate="{
              required: true,
              regex: /\S+@\S+\.\S+/,
            }"
            type="text"
            maxlength="50"
            name="email"
            label-content="Email ID"
            data-vv-as="Email ID"
            mark-required
            :placeholder="placeholders.email"
          />
          <div class="error">
            {{ errors.first('email') }}
          </div>
        </b-col>

        <b-col md="3">
          <BaseEInputText
            id="PhoneNumber"
            v-model="PhoneNumber"
            v-validate="{ required: false }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="PhoneNumber"
            label-content="Phone number#"
            data-vv-as="Phone number#"
            :placeholder="placeholders.phoneNumber"
          />
          <div class="error">
            {{ errors.first('PhoneNumber') }}
          </div>
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col>
          <BaseEButton type="submit" name="order">
            Order
          </BaseEButton>
        </b-col>
      </b-row>
    </b-form>
  </section>
</template>
<style lang="scss" module>
@import '@design';
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
